import React, { useEffect, useState } from 'react';
import Slider from 'components/Slider';
import Day from 'dayjs';
import 'dayjs/locale/es';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR


const SliderDays = ({days, daySelected, expressValidate, getHours, getWindowsOrderForm}) => {

    const [currentSlide, setCurrentSlide] = useState(null);
    const formatDay = (date) => {
        const dayText = Day(date).locale('es').format('dddd');
        if(Day(date).locale('es').format('YYYY-MM-DD') === Day().locale('es').format('YYYY-MM-DD')) {
            return 'Hoy';
        }

        const dayName = dayText.charAt(0).toUpperCase() + dayText.substring(1);
        return dayName.replace('.', '');
    }

    useEffect(() => {
        const currentIndex = days ? days.findIndex(item => item === daySelected) : 0;
        const $slides = document.querySelector(".slides");
        if($slides && currentIndex !== -1){
            const value = currentIndex / ($slides.clientWidth / 96);
            setCurrentSlide((value < 0.9) ? 0 : value);
        }else{
            setCurrentSlide(0);
        }
    },[]);

    return (
        <div className="date-delivery-slider-container">
            {(days && (days.length > 0 )) &&
            <Slider arrows={true} className="date-delivery-slider" currentSlide={currentSlide}>
                <div className="date-delivery-slide">
                    {days.map((item, i) => {
                        const dayWeek = item.split('-')[2];
                        const hoursDay = getWindowsOrderForm(item);
                        return (
                            <div key={i} className={"date-delivery-calendar-week" + ((daySelected == item)  ? ' select-date' : '') + ((!hoursDay.length && (i!=0 || !(expressValidate))) ? ' no-available' : '')} onClick={() => getHours(item)}>
                                <span className="date-delivery-day-name-week">{formatDay(item)}</span>
                                <span className="date-delivery-day-number-week">{dayWeek}</span>
                            </div>
                        )
                    })}
                </div>
            </Slider>}
        </div>
    )
}

SliderDays.propTypes = {
    getHours: PropTypes.func,
    days: PropTypes.array,
    getWindowsOrderForm: PropTypes.func,
    daySelected: PropTypes.string,
    expressValidate: PropTypes.bool
};
export default SliderDays;
